import { render, staticRenderFns } from "./Club.vue?vue&type=template&id=e5be34cc&scoped=true&"
import script from "./Club.vue?vue&type=script&lang=ts&"
export * from "./Club.vue?vue&type=script&lang=ts&"
import style0 from "./Club.vue?vue&type=style&index=0&id=e5be34cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5be34cc",
  null
  
)

export default component.exports